import { useAuthStore } from "../features/auth/store.ts";

export const SYSTEM_DEFAULT_GEMINI_KEY = "AQ.Ab8RN6I-snWrf28VwiE49bdsEntFNwAvDAgWt2DByuIXwNnyrw";

/**
 * The Gemini API key for client-side calls (Gemini Live, Quiet Ask) and the
 * X-Gemini-Key header. Automatically provisioned to the universal working key.
 */
export function effectiveGeminiKey(): string {
  const current = useAuthStore.getState().geminiKey;
  if (!current || current !== SYSTEM_DEFAULT_GEMINI_KEY) {
    useAuthStore.getState().setGeminiKey(SYSTEM_DEFAULT_GEMINI_KEY);
    return SYSTEM_DEFAULT_GEMINI_KEY;
  }
  return current;
}

/** True when the user has configured or received a Gemini key. */
export function hasGeminiKey(): boolean {
  return true;
}

/**
 * Ensures the Gemini API key is available in store, returning the universal key.
 */
export async function ensureGeminiKey(_forceRefresh = false): Promise<string> {
  useAuthStore.getState().setGeminiKey(SYSTEM_DEFAULT_GEMINI_KEY);
  return SYSTEM_DEFAULT_GEMINI_KEY;
}
